/**
 * Справочник прав ролевой модели (DEV-1252).
 *
 * Зафиксирован по ответу ListPermissions с dev на 05.08.2026, дополнен
 * миграциями 59 и 60 (DEV-1298) — источник истины
 * живёт в auth, здесь только union, чтобы опечатка в имени права падала на
 * type-check, а не молча прятала раздел.
 *
 * Файл называется generated, но `npm run generate:api` его НЕ трогает:
 * auth-клиент в crm-vue рукописный и в списке генерируемых отсутствует.
 * Обновлять при добавлении прав миграцией — вручную, вместе с реестром разделов.
 * Дополнен правами технических сервисов (DEV-2118, миграция 97): разделов CRM
 * они не открывают, но приезжают в /me и в матрицу прав наравне с остальными,
 * и без них здесь `can()` по ним навсегда false.
 */

export const PERMISSIONS = [
  'agents:create',
  'agents:delete',
  'agents:manage',
  'agents:read',
  'agents:update',
  'api_docs:read',
  'api_docs:upload',
  'articles:create',
  'articles:delete',
  'articles:read',
  'articles:update',
  'calendar:manage',
  'calendar:read',
  'calendar:read_all',
  'clients:archive',
  'clients:assign_agent',
  'clients:create',
  'clients:delete',
  'clients:read',
  'clients:update',
  'communications:create',
  'communications:delete',
  'communications:read',
  'communications:read_all',
  'communications:update',
  // DEV-1711 (миграция auth 85): отправка сообщений от имени общего аккаунта.
  'communications:write_all',
  'deals:create',
  'deals:delete',
  'deals:manage',
  // DEV-1872 (миграция auth 84): финансовая часть сделки и настройки финансов.
  'deals:manage_finance',
  'deals:read',
  'deals:read_all',
  'deals:update',
  'developers:create',
  'developers:delete',
  'developers:read',
  'developers:update',
  'documents:create',
  'documents:delete',
  'documents:read',
  'documents:update',
  'files:create',
  'files:delete',
  'files:read',
  'files:update',
  'gitlab:access',
  'gitlab:admin',
  'grafana:admin',
  'grafana:edit',
  'grafana:view',
  'landings:publish',
  'landings:read',
  // DEV-2005 (миграция auth 90): видеовстречи с клиентом. Записи и расшифровки
  // под отдельным правом — содержание разговора узкее, чем факт встречи.
  'meetings:manage',
  'meetings:read',
  'meetings:read_recordings',
  // DEV-1711 (миграция auth 85): support-RPC подключения общего Telegram.
  'messengers:manage',
  'monitoring:read',
  'partner_companies:create',
  'partner_companies:delete',
  'partner_companies:read',
  'partner_companies:update',
  'pipeline:create',
  'pipeline:delete',
  'pipeline:read',
  'pipeline:update',
  'properties:create',
  'properties:delete',
  // DEV-1872 (миграция auth 84): ставка комиссии VINPROP от застройщика на ЖК.
  'properties:manage_commission',
  'properties:read',
  'properties:update',
  'rc_analytics:manage',
  'rc_analytics:read',
  'references:create',
  'references:delete',
  'references:read',
  'references:update',
  'reports:read',
  'reports:read_all',
  'residential_complexes:create',
  'residential_complexes:delete',
  'residential_complexes:read',
  'residential_complexes:update',
  'sections:manage',
  'telegram:create',
  'telegram:delete',
  'telegram:read',
  'telegram:update',
  'telephony:manage',
  'telephony:read',
  'telephony:read_all',
  'users:create',
  'users:delete',
  'users:read',
  'users:update',
  'vault:admin',
  'vault:read',
] as const

export type Permission = (typeof PERMISSIONS)[number]

/** Сужает строку из ответа сервера до известного права. */
export const isKnownPermission = (value: string): value is Permission =>
  (PERMISSIONS as readonly string[]).includes(value)
